
(function () {

  const ROUTE = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  const ENDPOINT = ROUTE.replace(/\.json$/, '') + '.json';
  const MIN_CHARS = 2;

  function money(cents) {
    return window.TwoLaneCart
      ? window.TwoLaneCart.formatMoney(cents)
      : '$' + (Number(cents) / 100).toFixed(2);
  }

  function suggestImage(p) {
    if (typeof p.image === 'string') return p.image;
    if (p.image && p.image.url) return p.image.url;
    if (p.featured_image && p.featured_image.url) return p.featured_image.url;
    return '';
  }

  function suggestPrice(p) {
    if (typeof p.price === 'number') return p.price;
    return Math.round(parseFloat(String(p.price).replace(/[^0-9.]/g, '')) * 100) || 0;
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function debounce(fn, wait) {
    let t;
    function debounced() {
      const args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    }
    debounced.cancel = function () { clearTimeout(t); };
    return debounced;
  }

  function localSearch(term) {
    const needle = term.toLowerCase();
    const seen = new Set();

    return Array.prototype.slice.call(document.querySelectorAll('.product-card'))
      .map(function (card) {
        const nameEl  = card.querySelector('.product-card__name');
        const priceEl = card.querySelector('.product-card__price strong');
        const imgEl   = card.querySelector('.product-card__img');
        const linkEl  = card.querySelector('a[href]');
        if (!nameEl) return null;

        return {
          title: nameEl.textContent.trim(),
          url: linkEl ? linkEl.getAttribute('href') : 'product.html',
          price: priceEl ? Math.round(parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) * 100) : 0,
          featured_image: { url: imgEl ? imgEl.getAttribute('src') : '' }
        };
      })
      .filter(function (p) {
        if (!p || p.title.toLowerCase().indexOf(needle) === -1) return false;
        if (seen.has(p.title)) return false;
        seen.add(p.title);
        return true;
      })
      .slice(0, 6);
  }

  function attach(form) {
    const input = form.querySelector('input[type="search"]');
    if (!input) return;

    const panelId = 'predictive-' + (attach.n = (attach.n || 0) + 1);

    const panel = document.createElement('div');
    panel.className = 'predictive';
    panel.id = panelId;
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    form.appendChild(panel);

    const status = document.createElement('p');
    status.className = 'predictive__empty';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    form.appendChild(status);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', panelId);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('autocomplete', 'off');

    let activeIndex = -1;

    function options() {
      return Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
    }

    function setActive(i) {
      const opts = options();
      if (!opts.length) return;
      activeIndex = (i + opts.length) % opts.length;
      opts.forEach(function (o, n) {
        o.setAttribute('aria-selected', n === activeIndex ? 'true' : 'false');
        o.classList.toggle('is-active', n === activeIndex);
      });
      input.setAttribute('aria-activedescendant', opts[activeIndex].id);
      opts[activeIndex].scrollIntoView({ block: 'nearest' });
    }

    let seq = 0;
    let controller = null;
    let shownTerm = '';

    function cancelSearch() {
      search.cancel();
      seq++;
      if (controller) { controller.abort(); controller = null; }
    }

    function hide() {
      cancelSearch();
      panel.hidden = true;
      status.hidden = true;
      activeIndex = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function render(products, term) {
      activeIndex = -1;
      shownTerm = term;
      input.removeAttribute('aria-activedescendant');

      if (!products.length) {
        panel.hidden = true;
        panel.innerHTML = '';
        status.textContent = 'No matches. Try a broader term.';
        status.hidden = false;
        input.setAttribute('aria-expanded', 'false');
        return;
      }

      status.hidden = true;
      panel.innerHTML = products.map(function (p, i) {
        return '<a class="predictive__item" role="option" aria-selected="false"' +
                 ' id="' + panelId + '-opt-' + i + '" href="' + esc(p.url) + '">' +
                 '<img class="predictive__img" src="' + esc(suggestImage(p)) + '" alt="" loading="lazy">' +
                 '<span class="predictive__text">' +
                   '<span class="predictive__title">' + esc(p.title) + '</span>' +
                   '<span class="predictive__price">' + money(suggestPrice(p)) + '</span>' +
                 '</span>' +
               '</a>';
      }).join('');
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    const search = debounce(function (term) {
      const id = ++seq;
      if (controller) controller.abort();
      controller = typeof AbortController === 'function' ? new AbortController() : null;

      const url = ENDPOINT +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=6';

      function current() {
        return id === seq && input.value.trim() === term;
      }

      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (res) {
          if (!res.ok) throw new Error('suggest endpoint unavailable');
          return res.json();
        })
        .then(function (json) {
          if (!current()) return;
          const results = json.resources && json.resources.results;
          render((results && results.products) || [], term);
        })
        .catch(function (err) {
          if (!current() || (err && err.name === 'AbortError')) return;
          render(localSearch(term), term);
        });
    }, 250);

    input.addEventListener('input', function () {
      const term = input.value.trim();
      if (term.length < MIN_CHARS) { hide(); return; }
      search(term);
    });

    input.addEventListener('focus', function () {
      if (panel.innerHTML && input.value.trim() === shownTerm && shownTerm.length >= MIN_CHARS) {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) hide();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(); input.blur(); return; }
      if (panel.hidden) return;

      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIndex + 1); return; }
      if (e.key === 'ArrowUp')   { e.preventDefault(); setActive(activeIndex - 1); return; }
      if (e.key === 'Enter' && activeIndex > -1) {
        const opt = options()[activeIndex];
        if (opt) { e.preventDefault(); window.location.href = opt.getAttribute('href'); }
      }
    });
  }

  function init() {
    document.querySelectorAll('.header-search, .mobile-search').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
